import React from 'react';
import { Card, Form } from 'antd';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

const Layout9 = ({ onChange, initialData }) => {
  // console.log("--initialData", initialData);

  const [form] = Form.useForm();

  // Safely get the current content value, fallback to initialData or empty string
  const content = Form.useWatch('content', form) || initialData?.content || '';

  const modules = {
    toolbar: {
      container: [
        [{ font: [] }, { size: ['small', false, 'large', 'huge'] }],
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['blockquote'],
        ['link'],
        ['clean'],
      ],
    },
  };

  const formats = [
    'font',
    'size',
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'color',
    'background',
    'list',
    'align',
    'blockquote',
    'link',
  ];

  const handleEditorChange = (value) => {
    form.setFieldsValue({ content: value });
    onChange(form.getFieldsValue());
  };

  return (
    <Card
      style={{
        background: '#f9fafb',
        border: '2px dashed #1890ff',
      }}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{ content: initialData?.content || '' }}
        onValuesChange={(_, allValues) => onChange(allValues)}
      >
        <Form.Item name="content" style={{ marginBottom: 0 }}>
          <div>
            <style>{`
              .ql-editor p[data-columns="1"] {
                column-count: 1;
              }
              .ql-editor p[data-columns="2"] {
                column-count: 2;
                column-gap: 20px;
              }
              .ql-editor p[data-columns="3"] {
                column-count: 3;
                column-gap: 20px;
              }
            `}</style>
            <ReactQuill
              theme="snow"
              value={content}
              onChange={handleEditorChange}
              modules={modules}
              formats={formats}
              placeholder="Write something here..."
              style={{ height: '320px', marginBottom: '50px' }}
            />
          </div>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default Layout9;